<template>
  <div
    class="add-custom-button"
    @click.stop="action"
  >
    <a-icon type="plus" /> <span class="add-custom-button__link">Add</span>
  </div>
</template>

<script>

export default {
  methods: {
    action() {
      this.$emit('action')
    },
  },
}
</script>

<style lang="scss">
.add-custom-button {
  width: fit-content;
  color: var(--kit-color-primary);
  display: flex;
  align-items: center;
  gap: 5px;
  & > i {
    transition: transform .4s ease;
  }
  &:hover {
    cursor: pointer;
    & > i {
      transform: scale(1.15);
    }
    & .add-custom-button__link:after {
      width: calc(100% + .2em * 2);
    }
  }
  &__link {
    text-decoration: none;
    position: relative;
    &:after {
      background-color: var(--kit-color-primary);
      content: '';
      display: block;
      height: 1px;
      margin-left: calc(.2em * -1);
      margin-top: .2em;
      transition: width .5s;
      width: 0;
      position: absolute;
      bottom: 0;
    }
  }
}
</style>
